<template>
  <div class="bill-root">
    <div class="query-container">
      <el-date-picker
        v-model="startDate"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择起始日期"
        @change="query"
        style="margin-left: 10px; width: 160px"
      >
      </el-date-picker>
      至
      <el-date-picker
        v-model="endDate"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择截至日期"
        @change="query"
        style="margin-left: 10px; width: 160px"
      >
      </el-date-picker>

      <el-select
        v-model="providerId"
        clearable
        placeholder="请选择服务商"
        style="margin-left: 10px"
        @change="query"
      >
        <el-option v-for="item in providerOpts" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <el-select
        v-model="status"
        clearable
        placeholder="请选择状态"
        style="margin-left: 10px; width: 160px"
        @change="query"
      >
        <el-option
          v-for="item in statusOpts"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="serviceType"
        clearable
        placeholder="请选择服务类型"
        style="margin-left: 10px; width: 160px"
        @change="query"
      >
        <el-option
          v-for="item in serviceTypeOpts"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="serviceProjs"
        multiple
        placeholder="请选择项目"
        style="margin-left: 10px; width: 200px"
        @change="query"
      >
        <el-option
          v-for="item in serviceProjOpts"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="keyword"
        placeholder="司机编号或车牌号或创建人"
        clearable
        style="width: 220px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" style="margin-left: 10px" @click="query">查询</el-button>
    </div>

    <el-table
      :data="list"
      border
      style="width: 100%"
      max-height="700"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="时间" prop="serviceDate" width="160"></el-table-column>
      <el-table-column label="服务商" prop="providerName" width="130"> </el-table-column>
      <el-table-column label="服务类型">
        <template slot-scope="scope">
          {{ transeferIdNames(scope.row.serviceType) }}
        </template>
      </el-table-column>
      <el-table-column label="项目">
        <template slot-scope="scope">
          {{ scope.row.serviceProjs | serviceProjName(allServiceProjs) }}
        </template>
      </el-table-column>
      <el-table-column prop="staffName" label="检修员" width="80"> </el-table-column>
      <el-table-column prop="vehicleNo" label="车牌号" width="120"></el-table-column>
      <el-table-column prop="driverNo" label="司机" width="160">
        <template slot-scope="scope">
          {{ scope.row.driverNo }} {{ scope.row.driverName }}
        </template>
      </el-table-column>
      <el-table-column label="费用(元)" width="80" prop="amount">
        <template slot-scope="scope">
          {{ scope.row.amount ? scope.row.amount / 100 : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="服务状态">
        <template slot-scope="scope">
          {{ getBillStatusLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          {{ getBillAuditLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="cbyName" label="创建人">
        <template slot-scope="scope">
          {{ scope.row.cbyName ?? "系统" }}
        </template>
      </el-table-column>

      <el-table-column prop="createReason" label="创建原因">
        <template slot-scope="scope">
          {{ scope.row.createReason ? scope.row.createReason : scope.row.importantTips }}
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="rejectReason" label="驳回原因"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            v-if="scope.row.status == 0"
            @click="serviceBill(scope.row)"
            style="margin-right: 10px"
            >送检</el-link
          >
          <el-link
            type="primary"
            v-if="scope.row.status < 10"
            @click="modifyBill(scope.row)"
            style="margin-right: 10px"
            >修改</el-link
          >
          <el-link
            type="primary"
            v-if="scope.row.status < 10"
            @click="deleteBill(scope.row)"
            style="margin-right: 10px"
            >删除</el-link
          >
          <el-link type="primary" @click="viewBill(scope.row)" style="margin-right: 10px"
            >详情</el-link
          >
          <el-link type="primary" v-if="canPrintBill(scope.row)" @click="printBill(scope.row)"
            >打印</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 侧边栏 -->
    <el-dialog title="单据详情" :visible.sync="showBillDialog">
      <billDetail :bill-id="currentBill.id" v-if="!!currentBill"></billDetail>

      <!-- 弹出框 -->
      <el-dialog title="驳回原因" width="30%" :visible.sync="showRemarkDialog" append-to-body>
        <el-input v-model="remark" placeholder="请输入驳回原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showRemarkDialog = false">取消</el-button>
          <el-button @click="doAuditBillNotPass">确定</el-button>
        </span>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="currentBill && (currentBill.status == 10 || currentBill.status == 20)"
          type="primary"
          @click="auditBillPass(currentBill)"
          >通过</el-button
        >
        <el-button
          v-if="currentBill && (currentBill.status == 10 || currentBill.status == 20)"
          type="danger"
          @click="auditBillNotPass(currentBill)"
          >不通过</el-button
        >
        <el-button @click="(showBillDialog = false), (currentBill = null)">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改信息"
      :visible.sync="formVisible"
      width="600px"
      max-height="700"
      :size="size"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :size="size" label-width="140px" inline>
        <el-form-item label="车牌号：" prop="vehicleNo" clearable>
          <el-input v-model="form.vehicleNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="司机：" prop="driverName" clearable>
          <el-input v-model="form.driverName" disabled></el-input>
        </el-form-item>
        <el-form-item label="司机编号：" prop="driverNo" clearable>
          <el-input v-model="form.driverNo" disabled></el-input>
        </el-form-item>

        <el-form-item label="时间：" prop="billDate">
          <el-date-picker
            style="width: 200px"
            v-model="form.billDate"
            type="date"
            clearable
            value-format="yyyy-MM-dd hh:mm"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="modifyDate">保 存</el-button>
        <el-button type="info" :size="size" @click="formVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listServiceBill,
  toService,
  auditBillStatus,
  getServiceScopes,
  deleteBillInfo,
  changeProviderBillDate,
  getPartnerProviderList,
  getServiceProjs
} from "@/api/partner_admin";
import { DateUtil } from "@/util";
import billDetail from "../bill_detail";
export default {
  name: "serviceList",
  components: {
    billDetail
  },

  computed: {
    serviceProjOpts() {
      if (this.serviceType == "repair") {
        return this.repairProjs;
      } else if (this.serviceType == "vme") {
        return this.vmeProjs;
      } else {
        return [];
      }
    },

    allServiceProjs() {
      return this.repairProjs.concat(this.vmeProjs);
    }
  },

  filters: {
    serviceProjName(values, allServiceProjs) {
      if (values) {
        const nameMap = allServiceProjs.reduce((acc, item) => {
          acc[item.value] = item.name;
          return acc;
        }, {});
        return values.map((item) => nameMap[item]).join(",");
      }
      return "";
    }
  },

  data() {
    return {
      serviceScopeObjs: [],
      statusOpts: [
        { label: "待办", value: "0" },
        { label: "待审", value: "1" },
        { label: "未通过", value: "2" },
        { label: "已通过", value: "3" }
      ],
      serviceTypeOpts: [
        { label: "洗车", value: "wash" },
        { label: "维修", value: "repair" },
        { label: "保养", value: "maintenance" },
        { label: "检查", value: "inspection" },
        { label: "定损", value: "assess" },
        { label: "车载维护", value: "vme" }
      ],
      providerOpts: [],

      list: [],
      remark: null,
      showBillDialog: false,
      showRemarkDialog: false,
      currentBill: null,
      startDate: null,
      endDate: null,
      status: null,
      serviceType: null,
      serviceProjs: [],
      providerId: null,
      keyword: "",
      formVisible: false,
      form: {},
      size: "small",
      repairProjs: [],
      vmeProjs: []
    };
  },
  mounted() {
    this.initPage();
    this.query();
  },
  methods: {
    initPage() {
      this.endDate = DateUtil.getDayStr(15);
      this.startDate = DateUtil.format(new Date(), "yyyy-MM") + "-01";
      getServiceScopes().then((res) => {
        this.serviceScopeObjs = res.data || [];
      });

      getPartnerProviderList().then((res) => {
        const data = res.data || {};
        this.providerOpts = data.providers || [];
      });

      getServiceProjs().then((rs) => {
        const data = rs.data || {};
        this.repairProjs = data.repair || [];
        this.vmeProjs = data.vme || [];
      });
    },

    query() {
      listServiceBill(
        this.providerId,
        this.startDate,
        this.endDate,
        this.status,
        this.serviceType,
        this.keyword,
        this.serviceProjs
      ).then((res) => {
        this.list = res.data || [];
      });
    },

    printBill(bill) {
      window.open(
        this.$router.resolve({
          path: "/partner/bill/print",
          query: { id: bill.id, billType: bill.serviceType }
        }).href,
        "_blank"
      );
    },

    transeferIdNames(serviceType) {
      if (!serviceType) {
        return "";
      }

      for (var i = 0; i < this.serviceScopeObjs.length; i++) {
        if (this.serviceScopeObjs[i].value == serviceType) {
          return this.serviceScopeObjs[i].label;
        }
      }
      return "";
    },
    getBillStatusLabel(bill) {
      return bill.status < 10 ? "待办" : "已办";
    },
    getBillAuditLabel(bill) {
      if (bill.status < 10) {
        return "-";
      } else if (bill.status == 31) {
        return "不通过";
      } else if (bill.status == 30) {
        return "通过";
      } else {
        return "待审";
      }
    },
    viewBill(bill) {
      this.showBillDialog = true;
      this.currentBill = bill;
    },
    auditBillPass(bill) {
      this.$confirm("确定要通过该单据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        auditBillStatus([bill.id], bill.providerId, 30).then(() => {
          bill.status = 30;
          this.showBillDialog = false;
          this.currentBill = null;
        });
      });
    },
    auditBillNotPass() {
      this.showRemarkDialog = true;
      this.remark = null;
    },
    doAuditBillNotPass() {
      let me = this;
      let bill = this.currentBill;
      let rejectReason = this.remark;
      auditBillStatus([bill.id], bill.providerId, 31, rejectReason).then(() => {
        bill.status = 31;
        me.showRemarkDialog = false;
        me.showBillDialog = false;
        me.currentBill = null;
      });
    },

    modifyDate() {
      const param = {
        id: this.form.id,
        billDate: this.form.billDate
      };
      changeProviderBillDate(param).then(() => {
        this.formVisible = false;
        this.$message.success("修改成功");
        this.query();
      });
    },

    serviceBill(bill) {
      this.$confirm("确定要送检吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        toService(bill.id).then(() => {
          bill.status = 2;
        });
      });
    },

    modifyBill(bill) {
      this.form = { ...bill };
      this.formVisible = true;
    },

    deleteBill(bill) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteBillInfo(bill.id).then(() => {
          let idx = -1;
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id == bill.id) {
              idx = i;
              break;
            }
          }
          this.list.splice(idx, 1);
        });
      });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计：";
          return;
        }
        const property = column.property;

        if (column.property !== "amount") {
          sums[index] = "";
          return;
        }

        const values = data.map((item) => {
          return Number(item[property] / 100);
        });

        if (!values.every((value) => isNaN(value))) {
          const result = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = result ? result.toFixed(2) : 0;
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },

    canPrintBill(bill) {
      const { serviceType, status } = bill;
      const canPrintType =
        serviceType === "inspection" || serviceType === "maintenance" || serviceType === "repair";
      return canPrintType && status >= 10;
    }
  }
};
</script>

<style scoped>
.bill-root {
  padding: 10px;
}

.query-container {
  padding-bottom: 20px;
}
</style>
